import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import { useT } from '../i18n/useT';
import { useLang } from '../i18n/LanguageContext';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { isDark } = useTheme();
  const { isFr } = useLang();
  const t = useT();
  const tc = isDark ? '#FFFFFF' : '#1B2A4A';

  const toggleFAQ = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <section className="relative mt-32 px-[30px] lg:px-0">
      <div className="mx-auto max-w-[1140px]">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:pr-12 lg:w-1/2">
            <h2 className="text-[32px] lg:text-[48px] font-bold leading-[1.15] transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: tc }}>{t.faq.title}</h2>
            <div className="flex justify-start items-center mt-12 gap-4">
              <Link to="/terms"><p className="font-bold underline duration-500 transition-all" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : 'black' }}>{isFr ? 'Conditions générales' : 'Terms of Service'}</p></Link>
              <Link to="/privacy"><p className="font-bold underline duration-500 transition-all" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : 'black' }}>{isFr ? 'Politique de confidentialité' : 'Privacy Policy'}</p></Link>
            </div>
            <p className="mt-16 text-[14px] transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.4)' : undefined }}>Support</p>
            <a href="mailto:contact@openroom.com"><p className="font-bold duration-500 transition-all" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : 'black' }}>contact@openroom.com</p></a>
            <div className="mt-4">
              <a href="/login">
                <button className={`w-full lg:w-min lg:min-w-[266px] py-3.5 px-9 text-xl rounded-full border-2 duration-500 transition-all font-bold ${isDark ? 'tech-glow' : ''}`} style={{ backgroundColor: isDark ? 'transparent' : '#1B2A4A', color: isDark ? '#E6EBF2' : 'white', borderColor: isDark ? '#E6EBF2' : '#1B2A4A', fontFamily: '"Inter", sans-serif' }}>{t.nav.login}</button>
              </a>
            </div>
          </div>
          <div className="lg:w-1/2 mt-8 lg:mt-0">
            <article className="w-full flex flex-col gap-1">
              {t.faq.questions.map((item, index) => (
                <div key={index} className={`rounded-sm ${isDark ? 'tech-border' : ''}`} style={{ backgroundColor: isDark ? '#07070f' : '#1B2A4A' }}>
                  <div className="w-full flex items-center justify-between p-6 cursor-pointer" onClick={() => toggleFAQ(index)}>
                    <h6 className="text-white text-[15px] font-bold pr-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{item.question}</h6>
                    <div className="flex-shrink-0" style={{ color: isDark ? '#E6EBF2' : 'white' }}>{openIndex === index ? <Minus size={20} /> : <Plus size={20} />}</div>
                  </div>
                  <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-[500px] p-6 pt-0' : 'max-h-0 p-0'}`} style={{ backgroundColor: isDark ? '#030308' : '#F2F2F2' }}>
                    <p className="text-[15px] leading-[1.7] pt-4 transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.6)' : 'black' }}>{item.answer}</p>
                  </div>
                </div>
              ))}
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
